module.exports = __webpack_public_path__ + "static/media/bus tickets.ab7b79db.png";